import React, { FunctionComponent } from 'react';
import { Card, CardContent, Stack, Box, MenuItem } from '@mui/material';
import { CustomInput } from "../../components/CustomInput";
import { CustomSelect } from "../../components/CustomSelect";
import { CustomSnackbar } from "../../components/CustomSnackbar";
import { Button } from "../../components/Button";
import { User } from "../../model/User";
import Grid from '@mui/material/Unstable_Grid2';
import { useEditDealerInfo } from './hook';

interface IEditprofileForm<T> {
    data: T;
    onChange: (event: React.ChangeEvent<HTMLInputElement>, sectionName: string) => void;
}

export const EditDealerInfoForm: FunctionComponent<{ username: string }> = (props): JSX.Element => {
    const user = new User();

    const { state, snackbarState, onChange, onChangeSelect, onUpdateDealerInfo, onCloseSnackbar } = useEditDealerInfo(props.username)


    return (
        <>
            <Card sx={{ boxShadow: 2, mt: 2, borderRadius: 4 }}>
                <CardContent>
                    <Box mt={2} >
                        <Grid container columns={{ xs: 12, sm: 12, md: 12 }} rowSpacing={2}>
                            <Grid container xs={12} sm={12} md={12} columnSpacing={2} rowSpacing={2}>
                                <Grid xs={12} sm={6} md={6} width={"100%"} mt={2}>
                                    <CustomSelect width={"100%"} onChange={onChangeSelect} name="transferSet" value={state.transferSet} label="Transfer or Set" >
                                        <MenuItem value="t">Transfer</MenuItem>
                                        <MenuItem value="s" >Set</MenuItem>
                                        <MenuItem value="b" >Both</MenuItem>
                                    </CustomSelect>
                                </Grid>
                                <Grid xs={12} sm={6} md={6} width={"100%"} mt={2}>
                                    <CustomInput width={"100%"} name="transferText" value={state.transferText} onChange={onChange} height={35} label={{ text: "Transfer Text" }} />
                                </Grid>
                                <Grid xs={12} sm={6} md={6} width={"100%"} mt={2}>
                                    <CustomInput width={"100%"} name="scheduleText" value={state.scheduleText} onChange={onChange} height={35} label={{ text: "Schedule Text" }} />
                                </Grid>
                                <Grid xs={12} sm={6} md={6} width={"100%"} mt={2}>
                                    <CustomInput width={"100%"} name="timeZone" value={state.timeZone} onChange={onChange} height={35} label={{ text: "Time Zone" }} />
                                </Grid>
                                <Grid xs={12} sm={6} md={6} width={"100%"} mt={2}>
                                    <CustomInput width={"100%"} name="promotion" value={state.promotion} onChange={onChange} height={35} label={{ text: "Promotion" }} />
                                </Grid>
                                <Grid xs={12} sm={6} md={6} width={"100%"} mt={2}>
                                    <CustomInput width={"100%"} name="demo" value={state.demo} onChange={onChange} height={35} label={{ text: "Demo" }} />
                                </Grid>
                                <Grid xs={12} sm={6} md={6} width={"100%"} mt={2}>
                                    <CustomInput width={"100%"} name="priceLock" value={state.priceLock} onChange={onChange} height={35} label={{ text: "Price Lock" }} />
                                </Grid>
                                <Grid xs={12} sm={6} md={6} width={"100%"} mt={2}>
                                    <CustomInput width={"100%"} name="warranty" value={state.warranty} onChange={onChange} height={35} label={{ text: "Warranty" }} />
                                </Grid>
                                <Grid xs={12} sm={6} md={6} width={"100%"} mt={2}>
                                    <CustomSelect width={"100%"} onChange={onChangeSelect} name="installerInfo" value={state.installerInfo} label="Installer Info" >
                                        <MenuItem value="" >{" "}</MenuItem>
                                        <MenuItem value="employees" >Employees</MenuItem>
                                        <MenuItem value="subcontractors" >Subcontractors</MenuItem>
                                    </CustomSelect>
                                </Grid>
                                <Grid xs={12} sm={6} md={6} width={"100%"} mt={2}>
                                    <CustomInput width={"100%"} name="showroomAddress" value={state.showroomAddress} onChange={onChange} height={35} label={{ text: "Showroom Address" }} />
                                </Grid>
                                <Grid xs={12} sm={6} md={6} width={"100%"} mt={2}>
                                    <CustomInput width={"100%"} name="dealerPhone" value={state.dealerPhone} onChange={onChange} height={35} label={{ text: "Dealer Phone" }} />
                                </Grid>
                                <Grid xs={12} sm={6} md={6} width={"100%"} mt={2}>
                                    <CustomInput width={"100%"} name="website" value={state.website} onChange={onChange} height={35} label={{ text: "Website" }} />
                                </Grid>
                                <Grid xs={12} sm={6} md={6} width={"100%"} mt={2}>
                                    <CustomInput width={"100%"} name="comments" value={state.comments} onChange={onChange} height={35} label={{ text: "Comments" }} />
                                </Grid>
                                <Grid xs={12} sm={6} md={6} width={"100%"} mt={2}>
                                    <CustomSelect width={"100%"} label="Email Dealer" name="emailDealer" value={state.emailDealer} onChange={onChangeSelect} >
                                        <MenuItem value="0" >{" "}</MenuItem>
                                        <MenuItem value="3" >On transfer</MenuItem>
                                        <MenuItem value="2" >On set</MenuItem>
                                        <MenuItem value="4" >Both</MenuItem>
                                    </CustomSelect>
                                </Grid>
                                <Grid xs={12} sm={6} md={6} width={"100%"} mt={2}>
                                    <CustomInput width={"100%"} name="callCenterHours" value={state.callCenterHours} onChange={onChange} height={35} label={{ text: "Call Center Hours" }} />
                                </Grid>
                                <Grid xs={12} sm={6} md={6} width={"100%"} mt={2}>
                                    <CustomInput width={"100%"} name="businessName" value={state.businessName} onChange={onChange} height={35} label={{ text: "Business Name" }} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </CardContent>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", width: "100%", borderTop: 1, backgroundColor: "#FAFAFA", borderColor: "#00000026", p: 2 }}>
                    <Stack direction="row" spacing={2}>
                        <Button variant="outlined" width={120} height={40} label="Cancel" />
                        <Button width={120} height={40} label='Save' onClick={onUpdateDealerInfo} />
                    </Stack>
                </Box>
                <CustomSnackbar 
                    open={snackbarState.isOpen} 
                    variant="secondary" 
                    level={snackbarState.level as any} 
                    message={snackbarState.message} 
                    onClose={onCloseSnackbar}
                />
            </Card>
        </>
    )
}